export const debugEnabled = () =>
  new URLSearchParams(window.location.search).get('preview') === 'true' || process.env.NODE_ENV === 'development'

export const fullUrl = ({ legal_commander, url }) => {
  if (typeof(url) === "string" && url.includes('cardsphere')) return url
  return `https://edhrec.com/${legal_commander ? 'commanders' : 'cards'}/${url}`
}

export const isTouchDevice = () => window.innerWidth < 768

export const tcgplayerLink = ({ subId1, u }) => {
  const params = new URLSearchParams({ partnerpropertyid: '5237567', subId1, u })
  return 'https://partner.tcgplayer.com/c/4913290/1830156/21018?' + params.toString()
}

export const toURL = (string) => {
  string = string.toLowerCase()
  string = string.replaceAll(/[^a-z0-9\s]/gi, '')
  string = string.replaceAll(/\s+/gi, "-")
  return string
}
